// Module
var code = "<input data-bind=\"hasFocus: _hasFocus, attr: { placeholder: _labels.SEARCH_WITH_DOTS }\" type=\"text\" class=\"search-input subFormControl\"> <a class=\"subFormControl search-magnifier\"> <span class=\"icon-magnifier\"></span> </a> ";
// Exports
export default code;